var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCirclePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_633_13853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3766 57.0172C59.4698 57.0172 66.0249 50.5766 66.0249 42.6248C66.0249 34.6729 59.4698 28.2323 51.3766 28.2323C43.2835 28.2323 36.7284 34.6729 36.7284 42.6248C36.7284 50.5766 43.2835 57.0172 51.3766 57.0172ZM51.3766 64.2134C41.5989 64.2134 26.168 68.1981 26.168 77.7691L40.4756 85.8021L57.5085 87.1409L76.5853 77.7691C76.5853 68.1981 61.1544 64.2134 51.3766 64.2134Z",
    fill: "#86FFC6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.2968,
    cy: 51.0769,
    r: 36.3226,
    stroke: "#86FFC6",
    strokeWidth: 3.82343
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_633_13853",
    x: 0.317717,
    y: 0.0977764,
    width: 101.958,
    height: 101.958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.37239
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_633_13853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_633_13853",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCirclePlaceholder);
export default __webpack_public_path__ + "static/media/user-circle-placeholder.f57f248119212199565100f07eb3ce44.svg";
export { ForwardRef as ReactComponent };